@let data = section();

<section class="cms-faq tg-container tg-section">
    @if (data.content) {
        <div class="cms-faq__intro cms-content" [innerHTML]="data.content | trustHtml"></div>
    }

    @if (data.accordionItems.length) {
        <mat-accordion class="cms-faq__list" multi>
            @for (item of data.accordionItems; track item.id) {
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            @if (item.itemLabelImage?.url) {
                                <cms-image class="cms-faq__icon" [media]="item.itemLabelImage" />
                            }
                            {{ item.itemLabel }}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    @if (item.itemContent) {
                        <div class="cms-content" [innerHTML]="item.itemContent | trustHtml"></div>
                    }
                </mat-expansion-panel>
            }
        </mat-accordion>
    }
</section>
